module.exports = __webpack_public_path__ + "img/contact-drip-down.93455653.png";